import { initAnchorNavigation } from "modules/AnchorNavigation";

(function () {
    if (document.querySelectorAll(".js-job-page").length > 0) {
        let map: google.maps.Map | null = null;
        const jobPage = {
            store: {
                zoomLevel: null as number | null,
                latitude: null as number | null,
                longitude: null as number | null,
            },
            init: () => {
                jobPage.setMapDefaults();
                jobPage.renderMap();
                jobPage.stickyButtonMobile();
                initAnchorNavigation(".js-job-page");
                jobPage.anchorBarMobileScroll();
            },
            stickyButtonMobile: () => {
                const isElementInViewport = (el: Element) => {
                    const rect = el.getBoundingClientRect();
                    return (
                        rect.top >= 0 &&
                        rect.bottom >= document.documentElement.clientHeight
                    );
                };

                addEventListener("scroll", () => {
                    const windowSize = window.document.body.clientWidth;

                    if (windowSize < 580) {
                        const targetElement = document.getElementById("sticky-button__marker");
                        if (targetElement) {
                            if (!isElementInViewport(targetElement)) {
                                targetElement.classList.add("out-of-view");
                            } else {
                                targetElement.classList.remove("out-of-view");
                            }
                        }
                    }
                });
            },
            // Keeps the anchor bar scrolled to the active item on mobile
            anchorBarMobileScroll: () => {
                const anchorLinks = document.querySelectorAll<HTMLElement>(".anchor-links li");

                anchorLinks?.forEach((link) => {
                    link.addEventListener("click", () => {
                        if (document.documentElement.clientWidth < 800) {
                            const tabWrapper = link.parentElement?.parentElement;

                            if (tabWrapper != null) {
                                tabWrapper.scrollTo({
                                    top: 0,
                                    left: link.offsetLeft - 15,
                                    behavior: "smooth",
                                });
                            }
                        }
                    });
                });
            },
            parseCoordinates: (cord: string) => {
                return cord.includes(",") ? cord.replace(",", ".") : cord;
            },
            setMapDefaults: () => {
                const zoomLevel = (document.getElementById("ZoomLevel") as HTMLInputElement)?.value;
                const latitude = (document.getElementById("Latitude") as HTMLInputElement)?.value;
                const longitude = (document.getElementById("Longitude") as HTMLInputElement)?.value;
                if (zoomLevel && parseInt(zoomLevel) != 0) {
                    jobPage.store.zoomLevel = parseInt(zoomLevel);
                }
                if (latitude) {
                    jobPage.store.latitude = Number(jobPage.parseCoordinates(latitude));
                }
                if (longitude) {
                    jobPage.store.longitude = Number(jobPage.parseCoordinates(longitude));
                }
            },
            renderMap: () => {
                const mapContainer = document.getElementById("map");
                if (mapContainer) {
                    const initMap = async () => {
                        const { Map } = await google.maps.importLibrary("maps");
                        const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");
                        map = new Map(mapContainer, {
                            zoom: jobPage.store.zoomLevel!,
                            center: {
                                lat: jobPage.store.latitude!,
                                lng: jobPage.store.longitude!,
                            },
                            mapId: "99be96ce516de3af",
                        });
                        // Main job location marker
                        new AdvancedMarkerElement({
                            map,
                            position: {
                                lat: jobPage.store.latitude!,
                                lng: jobPage.store.longitude!,
                            },
                        });
                        // Directions logic
                        const directionsService = new google.maps.DirectionsService();
                        const directionsRenderer = new google.maps.DirectionsRenderer({
                            map: map,
                            panel: document.getElementById("directions-panel") as HTMLElement,
                        });
                        if (navigator.geolocation) {
                            navigator.geolocation.getCurrentPosition((position) => {
                                const origin = {
                                    lat: position.coords.latitude,
                                    lng: position.coords.longitude,
                                };
                                const destination = {
                                    lat: jobPage.store.latitude!,
                                    lng: jobPage.store.longitude!,
                                };
                                const request: google.maps.DirectionsRequest = {
                                    origin: origin,
                                    destination: destination,
                                    travelMode: google.maps.TravelMode.DRIVING,
                                };
                                void directionsService.route(request, (result, status) => {
                                    // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison -- Google Maps DirectionsStatus callback parameter type may not align with the enum definition
                                    if (status === google.maps.DirectionsStatus.OK) {
                                        directionsRenderer.setDirections(result);
                                    } else {
                                        console.error("Directions request failed due to " + status);
                                    }
                                });
                            });
                        }
                    }
                    void initMap();
                }
            },
            setMapPins: (jobs: Array<{ latitude: number; longitude: number; JobTitle: string; JobLocation: string }>) => {
                const intersectionObserver = new IntersectionObserver((entries) => {
                    for (const entry of entries) {
                        if (entry.isIntersecting) {
                            entry.target.classList.add("drop");
                            intersectionObserver.unobserve(entry.target);
                        }
                    }
                });
                const renderPins = async () => {
                    const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");
                    jobs.forEach((job) => {
                        const marker = new AdvancedMarkerElement({
                            map,
                            position: { lat: job.latitude, lng: job.longitude },
                            title: job.JobTitle,
                        });
                        const content = marker.content as HTMLElement;
                        if (content) {
                            content.style.opacity = "0";
                            content.addEventListener("animationend", () => {
                                content.classList.remove("drop");
                                content.style.opacity = "1";
                            });
                            const delay = 0.2 + Math.random();
                            content.style.setProperty("--delay-time", `${delay}s`);
                            intersectionObserver.observe(content);
                        }
                        const infoWindow = new google.maps.InfoWindow();
                        const infoContent = `<div class='info-window-title'>${job.JobTitle}</div> <div class='info-window-details'>${job.JobLocation}</div>`;
                        google.maps.event.addListener(marker, "click", () => {
                            infoWindow.close();
                            infoWindow.setContent(infoContent);
                            infoWindow.open(marker.map, marker);
                        });
                    });
                }
                void renderPins();
            },
        };
        jobPage.init();
    }
})();
